import { LowTonnageReason } from "@/pages/caster/models/catalogs/low-tonnage-reasons";
import { ErrorModal, HelmetDexteel } from "@dexteel/mesf-core";
import { CircularProgress, Grid2 as Grid } from "@mui/material";
import Paper from "@mui/material/Paper";
import React, { useState, useEffect } from "react";
import { TableLowTonnageReasons } from "./components/TableLowTonnageReasons";
import { getCatalogLowTonnageReasons } from "./repositories";

const LowTonnageReasonsPage: React.FC = () => {
	const [lowTonnageReasons, setLowTonnageReasons] = useState<
		LowTonnageReason[]
	>([]);
	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getLowTonnageReasonsFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogLowTonnageReasons();
		if (resp.ok) {
			setLowTonnageReasons(resp.data.tables[0].rows);
		} else {
			setError(resp.message);
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getLowTonnageReasonsFromAPI();
	}, []);

	const handleRefresh = () => {
		getLowTonnageReasonsFromAPI();
	};

	if (lowTonnageReasons) {
		return (
			<>
				<HelmetDexteel title="Low Tonnage Reasons - Configurations" />
				<Grid container justifyContent="center" alignItems="center">
					<Grid size={{ xs: 12, md: 12 }} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TableLowTonnageReasons
								lowTonnageReasons={lowTonnageReasons}
								isLoading={isLoading}
								onRefresh={handleRefresh}
							/>
						</Paper>
					</Grid>
				</Grid>

				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
	return (
		<Grid
			size={{ xs: 12 }}
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "70vh",
			}}
		>
			<CircularProgress />
		</Grid>
	);
};

export default LowTonnageReasonsPage;
